import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { Button } from 'new/elements/Button';
import classes from './RagActions.module.scss';
import Typography from 'new/elements/Typography';
import {
  useDraftContext,
  draftEventTypes,
} from 'new/components/flows/types/genai_rag/context/Draft/useDraftContext';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { getCurrentProjectId } from 'js/reducers/app/selectors';
import { clearSelectedFlow } from 'js/actions';
import { clearCurrentProjectId } from 'js/actions/currentProject';

interface RagActionsProps {}

export const RagActions = (props: RagActionsProps) => {
  const { draftActions, draftState, loading, handleEvent } = useDraftContext();
  const history = useHistory();
  const currentProjectId = useSelector(getCurrentProjectId);
  const dispatch = useDispatch();

  const inDraft =
    !!Object.values(draftState).length ||
    !!Object.values(draftActions).length ||
    !!draftState.dataSetsPendingDeletion?.length ||
    !!draftState.flowsPendingDeletion?.length;

  const handleExit = async () => {
    if (currentProjectId) {
      // Clear any selected flow state before redirecting
      dispatch(clearSelectedFlow() as any);
      history.replace(`${ROUTE_CONNECT}/projects/${currentProjectId}`);
      // Clear the project ID from Redux after redirecting

      dispatch(clearCurrentProjectId() as any);
    }
    handleEvent(draftEventTypes.EXIT);
  };

  const handlePublish = () => {
    handleEvent(draftEventTypes.PUBLISH);
  };

  return (
    <div className={classes.ragActionsContainer}>
      <Typography>{inDraft ? 'In Draft' : 'Saved'}</Typography>
      <Button disabled={loading || !inDraft} onClick={handlePublish} variant="contained">
        {loading ? <CircularProgress size={20} /> : 'Publish'}
      </Button>
      <div className={classes.verticalLine} />
      <Button variant="outlined" color="basic" onClick={handleExit}>
        {loading ? <CircularProgress size={20} /> : 'Exit'}
      </Button>
    </div>
  );
};
